import React, { ChangeEvent, ForwardedRef, forwardRef } from "react";

import { AppMobileNumberProps } from "./AppMobileNumberInput.props";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
const MobileNumberInputFieldWithFlag = forwardRef(
  function MobileNumberInputFieldWithFlag(
    props: AppMobileNumberProps,
    ref: ForwardedRef<HTMLInputElement>
  ): JSX.Element {
    return (
      <div
        className={
          "w-full h-full box-border py-2 items-baseline flex flex-col justify-end " +
          props.className
        }
      >
        <PhoneInput
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          ref={(e) => {
            return (ref = e);
          }}
          containerClass={" w-full text-black"}
          country="it"
          inputClass={"w-full h-full text-black"}
          dropdownClass={"mx-4"}
          placeholder={props.placeholder}
          inputProps={{ required: props.required }}
          value={props.value}
          inputStyle={{ height: "100%", width: "100%", color: "black" }}
          onChange={(phone) => {
            props.onChange(phone, {} as ChangeEvent<HTMLInputElement>);
          }}
        />
      </div>
    );
  }
);
export { MobileNumberInputFieldWithFlag };
